import { Button } from "../../../../_helpers/components/Button";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getRightsProfile } from "../../../../_api/RightsManagement";
import { useOutletContext } from "react-router-dom";

const ProfileCard = ({ profile, onClick }) => {
    return (
        <div
            onClick={onClick}
            className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer overflow-hidden group"
        >
            <div className="h-1 bg-linear-to-r from-app-primary to-app-secondary"></div>
            <div className="p-6">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                        <div className="flex items-center justify-center w-12 h-12 bg-linear-to-br from-app-primary to-app-secondary rounded-lg">
                            <svg
                                className="w-6 h-6 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                                />
                            </svg>
                        </div>
                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 group-hover:text-app-primary transition-colors">
                                {profile.name}
                            </h3>
                            <p className="text-sm text-gray-500 mt-1">
                                Profil de droits
                            </p>
                        </div>
                    </div>
                    <svg
                        className="w-5 h-5 text-gray-400 group-hover:text-app-primary transition-colors"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5l7 7-7 7"
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export const RightsManagement = () => {
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();
    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["INFO_RIGHT"]["features"];

    const [profiles, setProfiles] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        setIsLoading(true);
        getRightsProfile()
            .then((resp) => {
                setProfiles(resp.data);
            })
            .catch((error) => {
                console.error("Erreur lors du chargement des profils:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <div className="min-h-full bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between flex-wrap gap-4">
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900">
                                Gestion de droits
                            </h1>
                            <p className="mt-2 text-sm text-gray-600">
                                Gérez les profils de droits et les permissions de votre entreprise
                            </p>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            <Button
                                action={(e) => navigate("/company/profil/add")}
                                name={"Ajouter un profil de droits"}
                                type={"empty"}
                                isVisible={features_right["add_profil"]}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Contenu principal */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                    <div className="p-6 border-b border-gray-200">
                        <div className="flex items-center space-x-3">
                            <div className="flex items-center justify-center w-10 h-10 bg-linear-to-br from-app-primary to-app-secondary rounded-lg">
                                <svg
                                    className="w-6 h-6 text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                                    />
                                </svg>
                            </div>
                            <div>
                                <h2 className="text-xl font-bold text-gray-900">
                                    Liste des profils
                                </h2>
                                <p className="text-sm text-gray-500">
                                    {profiles.length} profil{profiles.length > 1 ? 's' : ''} disponible{profiles.length > 1 ? 's' : ''}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="p-6">
                        {isLoading ? (
                            <div className="flex items-center justify-center py-12">
                                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-app-primary"></div>
                            </div>
                        ) : profiles.length === 0 ? (
                            <div className="text-center py-12">
                                <svg
                                    className="mx-auto h-16 w-16 text-gray-400"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                                    />
                                </svg>
                                <h3 className="mt-4 text-lg font-medium text-gray-900">
                                    Aucun profil disponible
                                </h3>
                                <p className="mt-2 text-sm text-gray-500">
                                    Commencez par créer votre premier profil de droits pour gérer les permissions de votre équipe.
                                </p>
                                {features_right["add_profil"] && (
                                    <div className="mt-6">
                                        <Button
                                            action={(e) => navigate("/company/profil/add")}
                                            name={"Créer un profil de droits"}
                                        />
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                {profiles.map((profile) => (
                                    <ProfileCard
                                        key={profile.id}
                                        profile={profile}
                                        onClick={() => navigate("/company/profil/edit/" + profile.id)}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
